<template>
  <div id="product-settings" class="c-page c-product-settings">
    <div class="c-page__inner">
      <div class="l-columns-container l-columns-container--outmost">
        <div class="l-tablet-column--9">
          <h1 class="c-product-settings__headline f-headline">
            <strong>Hvilke nyhedsbreve</strong> vil du modtage?
          </h1>
        </div>
      </div>

      <div v-if="loading" class="l-columns-container l-columns-container--outmost">
        <div class="l-tablet-column--9">
          <h2>Indlæser</h2>
        </div>
      </div>

      <div
        v-if="products && products.length > 0"
        class="c-product-settings__products l-columns-container l-columns-container--outmost"
      >
        <div
          v-for="(product, index) in products"
          :id="'product-' + product.listid"
          :key="'images_' + product.listid"
          :class="{ 's-active': checkStatus(product.status) }"
          class="c-product-settings__product l-tablet-column--4"
          @click="toggleProduct(product, index)"
        >
          <img :src="product.listimage" class="c-product-settings__product__image" />

          <h3 class="f-subheadline">{{ product.listtitle }}</h3>
          <div class="c-product-settings__status f-small f-strong">
            <p class="product-status">{{ translateStatus(product.status) }}</p>
            <p :product="product.newState" class="product-status">{{ product.newState }}</p>
          </div>
          <p class="product-description f-text">{{ product.listdescription }}</p>
        </div>
      </div>

      <div :class="{ 's-new-changes': dataChanged }" class="c-product-settings__dialog">
        <div
          class="c-product-settings__dialog__inner l-columns-container l-columns-container--outmost"
        >
          <div class="l-tablet-column--9">
            <p v-if="saved">Dine indstillinger er gemt</p>
            <p
              v-else-if="!dataChanged"
            >Du kan til- og afmelde vores forskellige nyhedsbreve ved at klikke på dem.</p>

            <p v-else-if="dataChanged">Husk at trykke på gem.</p>
          </div>

          <div class="l-tablet-column--2 c-product-settings__save">
            <form class="c-form general-form">
              <SpinnerButton
                ref="save"
                :class="{ 's-disabled': !dataChanged && !redirect }"
                :disabled="!!saving"
                class="c-form__submit"
                cta="Gem"
                action="Gemmer"
                @clickaction="saveConfig"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerButton from "@/components/SpinnerButton.vue";

const axios = require("axios");

export default {
  name: "ProductSettings",
  components: {
    SpinnerButton
  },
  data() {
    return {
      redirect: this.$route.query.redirect || null,
      loading: false,
      saving: false,
      saveText: "Gem",
      saved: false,
      dataChanged: false,
      products: null,
      error: null,
      user: this.$route.meta.user
    };
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchData"
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed

    axios.defaults.headers.common = {
      Authorization: `bearer ${this.user.token}`
    };

    this.fetchData(true);
  },
  methods: {
    checkStatus(status) {
      const whitelist = ["added", "subscribed"];
      if (whitelist.indexOf(status) > -1) return true;

      return false;
    },
    toggleProduct(product, index) {
      if (this.saving) return;

      this.dataChanged = true;
      if (product.oldState) {
        this.products[index].status = this.products[index].oldState;
        product.oldState = null;
      } else {
        this.products[index].oldState = this.products[index].status;
        let newState = "removed";

        if (this.products[index].oldState != "subscribed") newState = "added";

        this.products[index].status = newState;
      }
    },
    saveConfig() {
      return axios
        .post(
          process.env.VUE_APP_PUMAS_API_URL + "central/product-config",
          this.products
        )
        .then(response => {
          this.$refs.save.reset();
          this.fetchData();
          this.saved = true;
          if (
            this.redirect &&
            (this.redirect === "invitation" || this.redirect === "landing")
          ) {
            this.$router.push({ name: "welcome" });
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },
    fetchData(showLoading) {
      this.loading = showLoading;

      return this.$userService
        .getProductConfig()
        .then(response => {
          this.products = response.data;
          this.loading = false;
        })
        .catch(error => {
          // Handle error
          console.log("catch", error);
        });
    },
    translateStatus(status) {
      const statuses = {
        subscribed: "Tilmeldt",
        cleaned: "Fejlmeldt",
        unknown: "Ikke tilmeldt",
        added: "Tilmeldes nu",
        removed: "Frameldes nu",
        unsubscribed: "Frameldt",
        pending: "Afventer at du godkender. Se din mail.",
        archived: "Frameldt"
      };

      console.log(status);

      if (status in statuses) {
        return statuses[status];
      } else {
        return "Ukendt status";
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../vars.scss";
@import "../mixins.scss";

.c-product-settings {
  &__headline {
    @include bp("max-width" #{$tablet - 1}) {
      margin-bottom: 1em;
    }
  }

  &__products {
    margin-top: $gutterVertical;
    justify-content: space-between;
  }

  &__product {
    margin-bottom: $gutterVertical / 2;

    &:last-child {
      margin-bottom: $gutterVertical;
    }

    &__image {
      margin-bottom: 1em;
      transition: opacity 200ms ease-in-out;
      opacity: 0.5;

      .s-active & {
        opacity: 1;
      }
    }
  }

  &__dialog {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: 1em;
    padding-bottom: 1em;
    background-color: $white;

    &__inner {
      justify-content: space-between;
      align-items: center;
    }

    p {
      margin: 0;
    }
  }

  &__save {
    justify-content: flex-end;
    align-items: center;

    .c-form__submit {
      margin-top: -0.5rem;
    }

    .spinner-button {
      // margin-right: 0;
      // margin-left: auto;
    }
  }

  // &__text {
  //   margin-bottom: 2em;

  //   * {
  //     margin-top: 1em;
  //     margin-bottom: 1em;

  //     &:first-child {
  //       margin-top: 0;
  //     }

  //     &:last-child {
  //       margin-bottom: 0;
  //     }
  //   }
  // }

  &__status {
    margin-top: 0.33em;
  }

  // &__save {
  //   position: relative;
  //   z-index: 1;
  // }
}
</style>